@if (osStore.confirmWindow()) {
  <div
    class="fixed inset-0 bg-black/40 backdrop-blur-[1px] flex items-center justify-center z-9999"
  >
    <div
      class="bg-white shadow-2xl border border-[#999] min-w-95 max-w-[90vw] flex flex-col animate-in fade-in zoom-in duration-200"
      (click)="$event.stopPropagation()"
    >
      <div
        class="bg-[#003399] text-white px-3 py-1.5 text-xs flex justify-between items-center select-none"
      >
        <div class="flex items-center gap-2">
          <span>Confirmation</span>
        </div>
        <button (click)="onCancel()" class="hover:bg-red-500 px-2 py-0.5 transition-colors">
          ✕
        </button>
      </div>

      <div class="p-6 bg-white flex items-start gap-4">
        <div class="text-3xl text-yellow-500">⚠️</div>
        <div class="flex flex-col gap-1">
          <h3 class="font-bold text-sm text-[#003399]">{{ osStore.confirmWindow()?.title }}</h3>
          <p class="text-sm text-[#1e1e1e] leading-relaxed">
            {{ osStore.confirmWindow()?.message }}
          </p>
        </div>
      </div>

      <div class="p-3 bg-[#f3f3f3] border-t border-[#ccc] flex justify-end gap-2">
        <button (click)="onCancel()" class="win-btn-secondary min-w-20">Annuler</button>
        <button (click)="onConfirm()" class="win-btn-primary min-w-20">Confirmer</button>
      </div>
    </div>
  </div>
}
